import {useMutation, type UseMutationOptions} from '@tanstack/react-query';
import {
	changePassword,
	type ChangePasswordResult,
	type ChangePasswordRequestOptions,
	type QueryError,
} from '../changePassword';
export * from '../changePassword';

export type UseReactQueryChangePasswordOptions = Omit<
	UseMutationOptions<
		ChangePasswordResult,
		QueryError,
		ChangePasswordRequestOptions,
		ChangePasswordResult
	>,
	'mutationFn'
> & {
	mutationFn?: typeof changePassword;
};

export const useReactQueryChangePassword = ({
	mutationFn = changePassword,
	...options
}: UseReactQueryChangePasswordOptions = {}) =>
	useMutation<
		ChangePasswordResult,
		QueryError,
		ChangePasswordRequestOptions,
		ChangePasswordResult
	>({
		mutationFn,
		...options,
	});

export default useReactQueryChangePassword;
